// extracted by mini-css-extract-plugin
module.exports = {"seeMoreContainer":"Discover_seeMoreContainer__1QH_F","title":"Discover_title__92ivQ"};